// extracted by mini-css-extract-plugin
export default {"appicon":"fad14404b3ad489d61ec","icon":"adcac2726e084d199773","name":"e0f4c56afb78b8858375"};